<template>
    <div>
        <topnav @tosearch="tosearch" :keywords="keyword" :toptype="toptype" :isSearch="path"></topnav>
        <div  style="min-height: 600px">
            <div class="marginauto conwidth topall">
                <div class="flex justify-start align-center" style="margin-bottom: 25px;">
                    <div class="" style="color: #959595;font-size: 16px;margin-right: 15px;line-height: 37px;width: 100px;">信息类别:</div>
                    <div class="flex justify-start align-center flex-wrap">
                        <div class="topone pointer" v-for="(item,index) in sortlist" :key="index" :class="item.type == sortIndex ? 'active':''" @click="tabchange(item.type)">{{item.name}}</div>
                    </div>
                </div>
                <div class="flex justify-start align-center">
                    <div class="" style="color: #959595;font-size: 16px;margin-right: 15px;line-height: 37px;width: 100px;">发布时间:</div>
                    <div class="flex justify-start align-center flex-wrap">
                        <div class="topone pointer" v-for="(item,index) in timelist" :key="index" :class="item.type == timeIndex ? 'active':''" @click="timechange(item.type)">{{item.name}}</div>
                    </div>
                </div>
            </div>
           <div class="line"></div>
           <div class="marginauto conwidth" style="padding: 10px 0 50px 0;">
               <div v-for="(item,index) in list" :key="index" class="animated slideInRight hvr-glow" style="width: 100%;">
                   <div class="newone flex pointer hvr-float" @click="todetail(item.id)" style="padding: 40px 20px;">
                    <div class="flex flex-direction justify-center aling-center" style="width: 212px;height: 212px;background-color: #416ec4;">
                        <div class="text-white text-center" style="font-weight: 600;font-size: 80px;">{{item.day}}</div>
                        <div class="text-white text-center" style="font-weight: 400;font-size: 24px;">{{item.year}}/{{item.month}}</div>
                    </div>
                    <div class="" style="padding: 0 30px;width: 75%">
                            <div class="text-cut" style="color: #2d2d2d;font-size: 22px;padding: 20px 0;">{{item.title}}</div>
                            <div class="text-cut2" style="line-height: 30px;font-size: 18px;margin: 15px 0;min-height: 60px;" v-html="item.content">

                            </div>
                            <div class="flex justify-between align-start" style="margin-top: 15px;">
                                <div class="" style="color: #888888;font-size: 18px;">{{item.small_title}}</div>
                                <div class="detail pointer">
                                    了解详情→
                                </div>
                            </div>
                    </div>
                </div>
               </div>
               
               <div v-if="!list.length && !load" style="min-height: 600px">
                   <nomore></nomore>
               </div>
               <div class="text-center" style="margin-top: 40px;">
                   <el-pagination
                    background
                    layout="prev, pager, next"
                    :pager-count="pagercount"
                    :hide-on-single-page="true"
                    :page-size="pagesize"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :total="totalnum"
                    >
                    </el-pagination>
               </div>
           </div>
        </div>
    </div>
</template>
<script>
import nomore from '../components/nomore.vue';
export default {
    computed: {
        // ...mapGetters(["config"]),
    },
  components: { nomore },
    data() {
        return{
            load: true,
            toptype: 2,
            pagesize: 10,
            totalnum: 0,
            currentPage: 1,
            pagercount: 7,
            path: '/information',
            sortlist: [{
                type: 0,
                name: '全部'
            },{
                type: 1,
                name: '科技'
            },{
                type: 2,
                name: '工信'
            },{
                type: 3,
                name: '人社'
            }],
            // 1河南省科学技术厅 2河南省工业和信息化厅 3河南省人力资源和社会保障厅   
            timelist: [{
                type: 0,
                name: '全部'
            },{
                type: 1,
                name: '一季度'
            },{
                type: 2,
                name: '二季度'
            },{
                type: 3,
                name: '三季度'
            },{
                type: 4,
                name: '四季度'
            }],
            sortIndex: 0,
            timeIndex: 0,
            list: [],
            keyword: ''
        }
    },
    methods:{
        todetail(id){
            // this.$router.push({path: '/policydetail',query:{id: id,type: 0}})
            let routeData = this.$router.resolve({
                name: 'policydetail',
                query: { id: id,type: 0 }
            });
            window.open(routeData.href, '_blank');
        },
        timechange(e){
            this.timeIndex = e;
            this.list = [];
            this.keyword = '';
            this.load = true;
            this.currentPage = 1;
            this.totalnum = 0;
            this.getlist();
        },
        tabchange(e){
            this.sortIndex = e;
            this.list = [];
            this.keyword = '';
            this.load = true;
            this.currentPage = 1;
            this.totalnum = 0;
            this.getlist();
        },
        tosearch(data){
            console.log(data)
            var data = JSON.parse(data);
            this.keyword = data.keyword;
            this.timeIndex = 0;
            this.sortIndex = 0;
            this.list = [];
            this.currentPage = 1;
            this.totalnum = 0;
            this.getlist();
        },
        handleSizeChange(){

        },
        handleCurrentChange(currentPage){
            this.currentPage = currentPage;
            this.getlist();
        },
        getlist(){
            var data = {
                type: this.sortIndex,
                start: this.currentPage,
                page_size: this.pagesize,
                quarter: this.timeIndex,
                keyword: this.keyword
            }
            this.$api.index.server_list(data).then(res => {
                this.list = res.data;
                this.totalnum = res.count;
                this.load = false;
            })
        },
    },
    created(){
        if(this.$route.query.keyword){
            this.keyword = this.$route.query.keyword;
            this.list = [];
            this.load = true;
            this.currentPage = 1;
            this.totalnum = 0;
            this.getlist()
        }else{
            this.getlist();
        }
        // console.log('this.$route.keyword',this.$route.query.keyword)
        
    }
}
</script>
<style scoped>
    .line{
        width: 100%;
        height: 14px;
        background-color: #eef1fa;
    }
    .topall{
        padding: 45px 0;
    }
    .topone{
        padding: 8px 18px;font-size: 16px;color: #4e4e4e;
    }
    .active{
        background-color: #ebf8ff;
	    border-radius: 4px;color: #1759d8;
    }
    .detail{
        color: #888888;font-size: 16px;
        width: 130px;
        height: 35px;
        line-height: 35px;text-align: center;
        background-color: #ffffff;
        border: solid 1px #888888;
    }
    .detail:hover{
        background-color: #1759d8;
        color: #eee;
        border-color: #1759d8;
    }
    /* .newone{
        border-bottom: 1px solid #eee;
    }
    .newone:hover{
        border-bottom: 0;
    } */
</style>


// WEBPACK FOOTER //
// information.vue?23a9ff52